import { ApiPropertyOptional } from '@nestjs/swagger';
import { IsOptional, IsString, MaxLength } from 'class-validator';

export class RejectPublicoDto {
  @ApiPropertyOptional({ description: 'Motivo del rechazo informado por el cliente.' })
  @IsOptional()
  @IsString()
  @MaxLength(1000)
  motivo?: string;
}
